// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21027304","453":"ef74469f","455":"6ddde55e","977":"b9633ac5"}[chunkId] + ".chunk.js";
};